import CreateOpenPlay from './CreateOpenPlay';

// The shared form reads the route id and loads the session for editing.
export default function EditOpenPlay({ activityType }) {
  return <CreateOpenPlay activityType={activityType} />;
}
